import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller, FormProvider } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import ActionBar from "../../../components/Shared/ActionBar"
import AdminLayout from "../../../components/Shared/AdminLayout"
import Container from "../../../components/Shared/Container"


function Offers(props) {

    useEffect(() => {
    }, [])

    return (
        <AdminLayout>
            <ActionBar title="Offers Overview"/>
            <Container>
            </Container>
        </AdminLayout>
    )
}

export default Offers
